import React from "react";


function SuccessIntegrationScreen(props) {
  return (
    <div
      id="course-screen"
      className={`${props.className} dashboard-container`}
    >
      <h1> Success Authorization</h1>
    </div>
  );
}

export default SuccessIntegrationScreen;
